import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IScheduleHistory } from '../interface/Expense/IScheduleHistory';
import { IDocument } from '../interface/IDocument';
import { IReprocessFee } from '../interface/Expense/IReprocessFee';

enum ExpensePaymentServiceEnum {
	putSave = '/',
	getHistory = '/get-history/',
	uploadDocument = '/upload-document/',
	reprocessPayment = '/reprocess-payment'
}

export class ExpensePaymentService extends ApiService {
	public scheduleDate = {
		save: async (newScheduleDate: Date, expenseId: number): Promise<void> => await this.POST(ExpensePaymentServiceEnum.putSave + expenseId, newScheduleDate),
		get: async (expenseId: number): Promise<IScheduleHistory[]> => await this.GET(ExpensePaymentServiceEnum.getHistory + expenseId)
	};

	public payment = {
		upload: async (fileToUpload: IDocument, expenseId: number): Promise<void> => await this.PUT(ExpensePaymentServiceEnum.uploadDocument + expenseId, fileToUpload)
	};


	constructor(restClient: AxiosInstance) {
		super(restClient, '/expense/payment');
	}
	public reprocessPayment = async (request: IReprocessFee): Promise<void> => await this.POST(ExpensePaymentServiceEnum.reprocessPayment, request);
}
